// extracted by mini-css-extract-plugin
export default {"contents":"CG-z","sectionHeading":"DG-z"};